export const farming = {
    "farming_titel_card_title" : "Precise Farming Mode",
    "farming_titel_card_text" : "Sie haben ihre Feldgrenzen im ITRF2014 und wollen mit APOS arbeiten? Dann können Sie mit diesem Werkzeug ganz einfach in das APOS Koordinatensystem ETRS89 transformieren.",
    "farming_coord_input_title" : "Zu transformierende Punkte"
}